<template>
  <section class="simulations-form">
    <embed-frame
      class="simulations-form-frame"
      endpoint="simulations/form"
      placeholder="Carregando..."
      :settings="embedSettings"
      :callbacks="embedCallbacks"
    />
  </section>
</template>

<script>
  import EmbedFrame from '@sdk/views/Embed/Frame.vue';

  export default {
    name: 'SimulationsForm',
    components: {
      EmbedFrame,
    },
    data() {
      return {
        simulation: {},
      };
    },
    computed: {
      embedSettings() {
        const {
          proposal_id: proposalID,
          proposal_attempt_id: proposalAttemptID,
        } = this.$route.params;

        const {
          store_id: storeID,
          simulation_uuid: simulationUUID,
          vehicle_id: usedID,
          commercial_control: commercialControl,
        } = this.$route.query;

        const customSettings = !!simulationUUID || !!proposalID;
        const advancedSettings = customSettings && commercialControl;

        const settings = {
          simulations: {
            form: {
              // WHO ran this simulation, stamped into proposal_simulations.origin
              // (via banks-api payload.origin). The embed never trusts an unknown
              // value: its parser falls back to `embed`, the default for a 3rd-party
              // widget on a host page. So a host that says nothing is read as a
              // plugin lead - and the web's SeedFromSimulationService then opens a
              // funnel conversation in the store's inbox for a customer the seller
              // already had in front of them. Same channel the showroom page uses
              // (web's public_simulator/new.html.erb stamps `public_simulator`).
              payload: { origin: 'pwa' },

              _enable_dynamic_banks: true,
              _enable_commercial_control_bypass: true,

              _condition: {
                _enable_custom_installments: true,
                _enable_exclusive_bank_fields: true,
                _enable_custom_settings: customSettings,
                _custom_settings_toggler: advancedSettings,
              },

              vehicle: {
                _asset_value: { visibility: true, readonly: false },
                _enable_price_commercial_control: !proposalID && !proposalAttemptID,
                _enable_vehicle_search_by_license_plate: true,

                credere_vehicle_id: usedID,
              },

              uuid: simulationUUID,
              store_id: storeID,
              _store_id: { visibility: true },

              _branches: {
                simulation: advancedSettings ? { visibility: 'hidden' } : null,
                lead: advancedSettings ? { visibility: 'hidden' } : null,
              },
            },
          },
          leads: {
            form: {
              _enable_cnpj: true,
            },
          },
        };

        if (proposalID) {
          // eslint-disable-next-line no-underscore-dangle
          settings.simulations.form._proposal = { id: proposalID };

          if (proposalAttemptID) {
            // eslint-disable-next-line no-underscore-dangle
            settings.simulations.form._proposal.proposal_attempt = { id: proposalAttemptID };
          }
        }

        return settings;
      },
      embedCallbacks() {
        return {
          'simulation:create': this.callback,
          'lead:create': this.leaded,
          'lead:udpate': this.leaded,
        };
      },
    },
    methods: {
      callback(data) {
        const query = {
          ...this.$route.query,
          store_id: data.data.payload.store_id,
        };

        const {
          proposal_attempt_id: attemptID,
          proposal_id: proposalID,
        } = this.$route.params;

        if (proposalID) {
          query.proposal_id = proposalID;
        }

        if (attemptID) {
          query.proposal_attempt_id = attemptID;
        }

        this.$router.push({
          name: 'simulations-read',
          params: {
            uuid: data.data.uuid,
          },
          query,
        });
      },
      leaded() {
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .simulations-form {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }
</style>
